import React from "react";
import AccountDiscovery from "@/features/accounts/components/AccountDiscovery";
import { PROSPECT_ROUTE } from "../../constants/prospectConfig";

const AccountDiscoveryComponent = AccountDiscovery as React.ComponentType<any>;

/** The Accounts tab is Account Discovery (custom search, look-alikes, most engaged). */
export default function AccountsTab({ isActive }: { isActive: boolean }) {
  return <AccountDiscoveryComponent embedded basePath={`${PROSPECT_ROUTE}/accounts`} isActive={isActive} />;
}
